// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 4V2H5V6H6V14H3V13H1V22H11V13H13V22H23V13H21V14H18V6H19V2H17V4H15V2H13V4H11V2H9V4H7ZM11.0039 7.99805V10.002H9V7.99805H11.0039ZM15.0039 7.99805V10.002H13V7.99805H15.0039Z"}}]};

const Castle1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-1-filled',
    ref,
    icon: element,
  },
));

Castle1FilledIcon.displayName = 'Castle1FilledIcon';

export default Castle1FilledIcon;
